import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useAppDispatch } from '@xver/hooks/useAppDispatch';
import { ME_QUERY_KEY } from '@xver/hooks/useMeQuery';
import { requestAuthUser } from '@xver/store/auth/auth.actions';
import { getErrorMessage } from '@xver/utils/error';
import { useTranslation } from 'react-i18next';

export function useUnlinkGitHubMutation() {
    const { t } = useTranslation('profile');
    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();

    return useMutation({
        mutationFn: () => Endpoints.v1.Authentication.githubUnlink(),
        onSuccess: async (response) => {
            notifications.show({
                title: t('githubConnection.toast.unlinkedTitle'),
                message: response?.message ?? t('githubConnection.toast.unlinkedMessage'),
                icon: <IconCheck size={18} color="#22c55e" />,
            });
            await queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY });
            dispatch(requestAuthUser());
        },
        onError: (err: unknown) => {
            notifications.show({
                title: t('githubConnection.toast.errorTitle'),
                message: getErrorMessage(err) ?? t('githubConnection.toast.errorMessage'),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
        },
    });
}
